import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./service-accordion.scss";

const ServiceAccordion = ({ service }: any) => {
  const [open, setOpen] = useState(true);

  const subServices = service?.subServices || [];
  const merchandise = service?.merchandise || [];

  const subTotal =
    subServices.reduce((s: number, i: any) => s + Number(i.amount || 0), 0) +
    merchandise.reduce((s: number, i: any) => s + Number(i.amount || 0), 0);

  return (
    <div className="description-accordion">
      <div className="accordion-header" onClick={() => setOpen(!open)}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span className="name-badge">{service.serviceName}</span>
          {service.needType && (
            <span className={`need-type-pill ${service.needType === 'pre_need' ? 'preneed' : 'at-need'}`}>
              {service.needType === "pre_need" ? "Preneed" : "Immediate Need"}
            </span>
          )}
        </div>
        <span className={`caret-icon ${open ? "open" : ""}`}>⌃</span>
      </div>

      {open && (
        <div className="accordion-body">
          <div className="accordion-row even">
            <strong>Sub-Services</strong>
            <span className="description-amount">Amount</span>
          </div>

          {subServices.length ? (
            subServices.map((item: any, i: number) => (
              <div key={i} className="row-with-price">
                <div className="row-left">
                  <CheckCircleIcon className="tick-icon" />
                  <span>{item.name}</span>
                </div>
                <span>${item.amount}</span>
              </div>
            ))
          ) : (
            <div className="accordion-empty">Sub services not available</div>
          )}

          <div className="accordion-row even">
            <strong>Merchandise</strong>
          </div>

          {merchandise.length ? (
            merchandise.map((item: any, i: number) => (
              <div key={i} className="row-with-price">
                <div className="row-left">
                  <CheckCircleIcon className="tick-icon" />
                  <span>
                    {item.name} ({item.quantity} × ${item.price})
                  </span>
                </div>
                <span>${item.amount}</span>
              </div>
            ))
          ) : (
            <div className="accordion-empty">Merchandise not available</div>
          )}

          <div className="accordion-subtotal">
            <span>Subtotal</span>
            <span>${subTotal}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceAccordion;
